module.exports = __webpack_public_path__ + "media/tipaudio.90fccd05.mp3";